export default {"src":"/_next/static/media/logo.10858fac.svg","height":38,"width":154,"blurWidth":0,"blurHeight":0};